"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HackerModal = void 0;
const react_1 = require("@chakra-ui/react");
const framer_motion_1 = require("framer-motion");
const react_2 = __importDefault(require("react"));
const animation_1 = require("../utils/animation");
const HackerBox_1 = require("./HackerBox");
const ModalCloseButton_1 = require("./ModalCloseButton");
const INITIAL_ANIMATION_STATE = {
    scale: 0.1,
    opacity: 0.5,
    transition: {
        ease: 'easeIn',
        duration: 0.2,
    },
};
const EXIT_ANIMATION_STATE = {
    scale: 0.1,
    opacity: 0.5,
    transition: {
        ease: 'easeOut',
        duration: 0.2,
    },
};
const BASE_ANIMATION_STATE = {
    scale: 1,
    opacity: 1,
    transition: {
        ease: 'easeIn',
        duration: 0.2,
    },
};
const HackerModal = ({ onExitComplete, children, layoutId, show, onClose, hideCloseButton, isFullscreen, containerProps, }) => {
    return (react_2.default.createElement(react_2.default.Fragment, null,
        react_2.default.createElement(framer_motion_1.AnimatePresence, { onExitComplete: onExitComplete }, show && (react_2.default.createElement(animation_1.MotionFlex, Object.assign({ initial: INITIAL_ANIMATION_STATE, exit: EXIT_ANIMATION_STATE, animate: BASE_ANIMATION_STATE, direction: "column", position: "absolute", top: [0, '20px'], bottom: [0, '20px'], left: [0, '32px'], right: [0, '32px'], zIndex: 10, marginX: "auto", layoutId: layoutId }, containerProps),
            !hideCloseButton && react_2.default.createElement(ModalCloseButton_1.ModalCloseButton, { onClose: onClose }),
            react_2.default.createElement(HackerBox_1.HackerBox, { height: isFullscreen ? '100%' : undefined, maxH: "full", minH: ['full', 'initial'], innerContainerProps: {
                    paddingTop: [1, 3],
                    paddingX: [1, 3],
                    paddingBottom: 0,
                    bgColor: 'black',
                    display: 'flex',
                    overflowY: 'auto',
                    borderStyle: ['none', 'solid'],
                    transition: 'height 0.2s',
                } }, children),
            react_2.default.createElement(react_1.Box, { flex: 1, onClick: onClose })))),
        react_2.default.createElement(react_1.Box, { position: "absolute", top: 0, bottom: 0, height: show ? undefined : 0, left: 0, right: 0, bgColor: show ? 'blackAlpha.700' : 'transparent', zIndex: 5, onClick: onClose })));
};
exports.HackerModal = HackerModal;
//# sourceMappingURL=HackerModal.js.map